/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBadge2S = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11.305 2.281a1 1 0 0 1 1.39 0l1.874 1.813 2.581-.365a1 1 0 0 1 1.125.817l.45 2.568 2.303 1.221a1 1 0 0 1 .43 1.323L20.313 12l1.145 2.342a1 1 0 0 1-.43 1.323l-2.302 1.221-.45 2.568a1 1 0 0 1-1.126.817l-2.581-.365-1.874 1.813a1 1 0 0 1-1.39 0L9.43 19.906l-2.58.365a1 1 0 0 1-1.126-.817l-.45-2.568-2.303-1.222a1 1 0 0 1-.43-1.322L3.687 12 2.542 9.658a1 1 0 0 1 .43-1.323l2.303-1.221.45-2.568A1 1 0 0 1 6.85 3.73l2.581.365zM9.538 14.45v1.05h4.73v-1.27h-2.7l1.01-1.11c.414-.46.74-.853.98-1.18.247-.333.424-.633.53-.9.107-.267.16-.533.16-.8 0-.653-.213-1.157-.64-1.51-.427-.353-1.027-.53-1.8-.53a4.33 4.33 0 0 0-1.07.14c-.36.087-.697.21-1.01.37v1.34c.687-.367 1.3-.55 1.84-.55.767 0 1.15.303 1.15.91 0 .147-.04.307-.12.48a3.38 3.38 0 0 1-.42.62 21.2 21.2 0 0 1-.82.94z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBadge2S as Badge2S };
